import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleCustomsDeclarationMaterialService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SingleCustomsDeclarationMaterialCreateDto,
  SingleCustomsDeclarationMaterialDto,
  SingleCustomsDeclarationMaterialExcelDownloadDto,
  SingleCustomsDeclarationMaterialUpdateDto,
} from 'orchestrator';
import { SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG, SINGLECUSTOMSDECLARATIONMATERIAL_FIELDS } from './single-customs-declaration-material.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-single-customs-declaration-material',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SingleCustomsDeclarationMaterialService, ConfirmationService],
  templateUrl: './single-customs-declaration-material.html',
  styleUrl: './single-customs-declaration-material.scss',
})
export class SingleCustomsDeclarationMaterial extends BaseHierarchicalCrudComponent<
  SingleCustomsDeclarationMaterialDto,
  SingleCustomsDeclarationMaterialCreateDto,
  SingleCustomsDeclarationMaterialUpdateDto,
  SingleCustomsDeclarationMaterialExcelDownloadDto
> {
  service = inject(SingleCustomsDeclarationMaterialService);
  config = SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG;
  fields = SINGLECUSTOMSDECLARATIONMATERIAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: SingleCustomsDeclarationMaterialDto): SingleCustomsDeclarationMaterialUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SingleCustomsDeclarationMaterial';
  }
}
